// @flow

import { Alert } from '@gandi/reshaped';

import { useTranslator } from '@gandi/translate';

import { useConflictInfo } from 'src/hooks/useConflictInfo';

type Props = { children: React.Node };

export function IncompatibleBilledMessage({
  children,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const { failureCartOwners, supportURL } = useConflictInfo();

  if (failureCartOwners !== 409) return <>{children}</>;

  return (
    <Alert title={__('Invoice contact')}>
      <div
        dangerouslySetInnerHTML={__(
          'This shopping cart cannot be billed to any of your organizations.' +
            '\n\n' +
            'This is likely because it contains one or more domain names ' +
            'that are managed by a reseller organization to which ' +
            'you do not have sufficient permissions.' +
            '\n\n' +
            'If you feel that this message is in error, ' +
            'please [contact customer support](%(supportURL)s).',
          {
            // XXX: withMarkdown introduce escape `_` with a backslash which change `supportURL`
            // fortunatly, the page linked is correctly rendered at the moment.
            withMarkdown: true,
            supportURL,
          },
        )}
      />
      <div
        dangerouslySetInnerHTML={__(
          'Alternatively, you can ' +
            '<a href="#" role="button" id="delete-cart">delete this shopping cart</a>.',
          { withHTML: true },
        )}
      />
    </Alert>
  );
}
